import { Progress } from "antd";
import React from "react";
import styled from "styled-components";
const Container = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
    align-items: center;
`;
const Title = styled.p`
    color: #1e2228;
    font-size: 12px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    text-align: center;
    white-space: nowrap;
    margin-top: ${(props) => (props.removeMargin ? 0 : "15px")};
    margin-bottom: 12px;
`;
const Text = styled.p`
    color: #1e2228;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    margin: 30px 0 12px 0;

`;
const ScoreValues = styled.p`
    color: #1e2228;
    font-size: 12px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    margin-top: 2px;
    margin-bottom: 12px;
`;
const ProgressContainer = styled.div`
    & > div {
        & > div {
            & > span {
                color: #1e2228;
                font-size: 12px;
                font-style: normal;
                font-weight: 700;
                line-height: normal;
            }
        }
    }
`;

const Score = ({ title, color, percent, stroke, size, removeMargin,text,boldText }) => {
    // Handle null/undefined percent values
    const safePercent = percent != null ? percent : 0;
    
    return (
        <Container>
            <Title removeMargin={removeMargin}>{title}</Title>
            <ProgressContainer>
                <Progress
                    status={"normal"}
                    strokeLinecap={"square"}
                    type="circle"
                    percent={safePercent}
                    strokeWidth={stroke}
                    strokeColor={`${color}`}
                    width={size ? size : "120"}
                />
            </ProgressContainer>
            {/* <Text>{text}</Text>
            <ScoreValues>{boldText}</ScoreValues> */}
        </Container>
    );
};

export default Score;
